import { MenuItem, Typography } from '@mui/material';
import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import QuorumBusiness from '@/dominio/QuorumBusiness';
import { FilterAlt } from '@mui/icons-material';

class AlertaProcessosSemConfirmacaoDeVoto extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            quantidadeProcessosSemConfirmacaoDeVoto: computed,
            handleClickIcone: action
        });
    }

    get quantidadeProcessosSemConfirmacaoDeVoto() {
        return this.observableProps.processos.length;
    }

    handleClickIcone = () => {
        this.store.alterandoValorFiltro = true;
        this.setTimeout(() => {
            this.store.filtros.reset();
            this.store.filtros.filtroVotacaoComVotoDiferenteDeConfirmado.valor = true;
            this.store.alterandoValorFiltro = false;
        });
    };

    render() {
        if (!this.quantidadeProcessosSemConfirmacaoDeVoto || this.quantidadeProcessosSemConfirmacaoDeVoto <= 0) {
            return null;
        }

        return (
            <MenuItem
                style={{ display: 'flex', cursor: 'pointer' }}
                onClick={this.handleClickIcone}
            >
                <FilterAlt style={{ marginRight: '12px', color: 'darkorange', fillOpacity: '1' }} />
                <Typography>
                    {this.quantidadeProcessosSemConfirmacaoDeVoto +
                        ' processo' +
                        (this.quantidadeProcessosSemConfirmacaoDeVoto === 1 ? '' : 's')}{' '}
                    em que há pelo menos um participante sem
                    <br />
                    voto confirmado
                </Typography>
            </MenuItem>
        );
    }
}

export default inject('stores')(observer(AlertaProcessosSemConfirmacaoDeVoto));
